'use client';
import { Grid } from '@mui/material';
import { ErrorPage } from '@repo/ui';

export default function Error() {
  return (
    <Grid container direction={'column'} justifyContent={'center'} sx={{ height: '100vh' }}>
      <ErrorPage />
    </Grid>
  );
}
